import * as React from "react";
import {
  Button,
  Create,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  required,
  useRedirect,
} from "react-admin";
import { Grid } from "@mui/material";

const SiteCreateToolbar: React.FC = (props) => {
  const redirect = useRedirect();
  return (
    <Toolbar {...props}>
      <SaveButton />
      <Button
        variant="outlined"
        color="warning"
        label="Annuler"
        size="large"
        onClick={() => redirect("list", "sites")}
        sx={{ ml: 2, pl: 4 }}
      />
    </Toolbar>
  );
};

export const SiteCreate: React.FC = () => (
  <Create resource="sites" redirect="list" title="Créer un nouveau Site">
    <SimpleForm toolbar={<SiteCreateToolbar />}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextInput
            source="internalCode"
            label="Code site interne"
            placeholder="Entrez le code interne du site"
            validate={[required("Le code interne est requis")]}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextInput
            source="name"
            label="Nom du site"
            placeholder="Entrez le nom du site"
            validate={[required("Le nom du site est requis")]}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextInput
            source="address"
            label="Adresse"
            placeholder="Entrez l'adresse du site"
            validate={[required("L'adresse est requise")]}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextInput
            source="zipCode"
            label="Code postal"
            placeholder="Entrez le code postal du site"
            validate={[required("Le code postal est requis")]}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, md: 12 }}>
          <TextInput
            source="city"
            label="Ville"
            placeholder="Entrez le nom de la ville"
            validate={[required("La ville est requise")]}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, md: 12 }}>
          <TextInput
            source="siret"
            label="SIRET"
            placeholder="Entrez le SIRET du site"
            validate={[required("Le SIRET est requis")]}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <TextInput
            source="contactName"
            label="Interlocuteur exploitation"
            placeholder="Entrez le nom de l'interlocuteur"
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <TextInput
            source="email"
            type="email"
            label="Email"
            placeholder="Entrez l'email du site"
            validate={[required("L'email est requis")]}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <TextInput
            source="phone"
            label="Tél exploitation"
            placeholder="Entrez le numéro de téléphone"
            validate={[required("Le téléphone est requis")]}
            fullWidth
          />
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);
